import React, { Component } from "react";
import Header from "../../layout/Header";
import BannerSimple from "../../layout/BannerSimple";
import Footer from "../../layout/Footer";
import ListOption from "../../layout/ListOption";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import PPE1 from "./PPE1";
import PPE2 from "./PPE2";
import PPE3 from "./PPE3";
import PPE4 from "./PPE4";

let title = 'Projet Personnel Encadré';

class PPE extends Component {
	defineTitle(_title){
		document.title = `${_title ? _title : title} - ${window.APP_NAME}`;
		window.resetScript()
	}

	componentDidMount() {
		let { session } = this.props.match.params;
		if (session) {
			this.defineTitle(`${title} ${session}`);
		}
	}

	render() {
		let { session } = this.props.match.params;
		let display;

		if (session) {
			this.defineTitle(`${title} ${session}`);
		}

		switch (session) {
			case "1":
				display = (
					<>
						<BannerSimple title={`${title} ${session}`} boxElement={ [ { name: "Accueil", link: "/" }, { name: title, link: '/ppe' }, { name: `${title} ${session}`, link: window.location.pathname } ] } />

						<PPE1 title={`${title} ${session}`} />
					</>
				);
				break;
			case "2":
				display = (
					<>
						<BannerSimple title={`${title} ${session}`} boxElement = { [ { name: "Accueil", link: "/" }, { name: title, link: '/ppe' }, { name: `${title} ${session}`, link: window.location.pathname } ] } />

						<PPE2 title={`${title} ${session}`} />
					</>
				);
				break;
			case "3":
				display = (
					<>
						<BannerSimple title={`${title} ${session}`} boxElement = { [ { name: "Accueil", link: "/" }, { name: title, link: '/ppe' }, { name: `${title} ${session}`, link: window.location.pathname } ] } />

						<PPE3 title={`${title} ${session}`} />
					</>
				);
				break;
			case "4":
				display = (
					<>
						<BannerSimple title={`${title} ${session}`} boxElement = { [ { name: "Accueil", link: "/" }, { name: title, link: '/ppe' }, { name: `${title} ${session}`, link: window.location.pathname } ] } />

						<PPE4 title={`${title} ${session}`} />
					</>
				);
				break;
			default:
				display = (
					<>
						{ this.defineTitle() }

						<BannerSimple title={title} boxElement = { [ { name: "Accueil", link: "/" }, { name: title, link: window.location.pathname } ] } />

						<ListOption title={title} description="Cette section présente les travaux fait en classe encadrer par les professeurs." list={
							[
								{
									title: `${title} 1`,
									description: `Projet NowSong, Partie Réseau`,
									link: '/ppe/1',
									lnr_icon: 'lnr-book'
								},
								{
									title: `${title} 2`,
									description: `Projet NowSong, Application Web`,
									link: '/ppe/2',
									lnr_icon: 'lnr-book'
								},
								{
									title: `${title} 3`,
									description: `Projet CV Creator, Logiciel Java`,
									link: '/ppe/3',
									lnr_icon: 'lnr-book'
								},
								{
									title: `${title} 4`,
									description: `Projet AniCommerce, Application Web, Webservice et Application Android`,
									link: '/ppe/4',
									lnr_icon: 'lnr-book'
								},
							]
						} />
					</>
				);
		}

		return (
			<>
				<Header active={ "Projet Personnel Encadré" } modeDark={ true } />

				{ display }

				<Footer />
			</>
		);

	}
}

PPE.propsTypes = {};

const mapStateToProps = state => ({});

export default connect(
	mapStateToProps,
	{  }
)(withRouter(PPE))